export enum ProcessingState {
    Processing = "processing",
    Processed = "processed",
    Failed = "failed"
}

export interface TerminationVM {
    EmployeeID: number;
    isSelected: boolean;
    processingState: ProcessingState;
}

export interface NewHireVM {
    isSelected: boolean;
    processingState: ProcessingState;
    EmployeeID: number;
    ADPEmployeeID: number;
    SSN: string;
    FEIN: string;
}

export interface ChangeHistoryVM {
    isSelected: boolean;
    processingState: ProcessingState;
    EmployeeID: number;
    EmployeeChangeHistoryID: number;
}

export interface BatchProcessResult {
    Succeeded: number[];
    Forbidden: number[];
    Message: string;
}

export interface DirectDepositVM {
    IsSelected: boolean;
    processingState: ProcessingState;
    DirectDepositID: number;
    EmployeeID: number;
    FirstName: string;
    LastName: string;
    CompanyName: string;
}
